import { CommonModule } from '@angular/common';
import { Component, inject, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatOptionModule } from '@angular/material/core';
import { AiKnowledgeService } from '../ai-knowledge.service';
import { AppsForKnowledgeSourceComponent } from '../apps-for-knowledge-source/apps-for-knowledge-source.component';
import { AiKnowledgeI18nModule } from '../assets/i18n/ai-knowledge-i18n.module';

export interface DeleteCustomKnowledgeData {
  knowledgeSourceId: string;
}

@Component({
  selector: 'ai-knowledge-delete-custom-knowledge-dialog',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    AiKnowledgeI18nModule,
    MatButtonModule,
    MatDialogModule,
    GalaxyFormFieldModule,
    MatOptionModule,
    AppsForKnowledgeSourceComponent,
  ],
  providers: [AiKnowledgeService],
  templateUrl: './delete-custom-knowledge.component.html',
})
export class DeleteCustomKnowledgeComponent {
  private readonly knowledgeService = inject(AiKnowledgeService);

  constructor(
    public dialogRef: MatDialogRef<DeleteCustomKnowledgeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteCustomKnowledgeData,
  ) {}

  cancel(): void {
    this.dialogRef.close();
  }

  async delete(): Promise<void> {
    await this.knowledgeService.deleteKnowledgeSource(this.data.knowledgeSourceId);
    this.dialogRef.close(true);
  }
}
